var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('elevenlabs-convai',{attrs:{"agent-id":"DBPliIk7o0vdLLRL6EX6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }